import { chakra, Button, Box } from "@chakra-ui/react";

export const AnalysisButton = chakra(Button, {
  baseStyle: {
    bg: "#40599B",
    px: "15px",
    py: "4px",
    h: "45px",
    color: "white",
    _hover: { bg: "#2f4477" },
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: "5px", // spacing between text and icon
    width: "auto", // Ensures width adjusts to content
    minWidth: "auto", // Removes any minimum width constraints
    whiteSpace: "nowrap", // Prevents text wrapping
  },
});

export const HeadingContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
